import yaml from 'js-yaml';

/**
 * Parse YAML file content and convert to JavaScript object
 *
 * @param {string} fileContent - Raw YAML file content as string
 * @returns {object} Parsed JavaScript object
 * @throws {Error} If YAML parsing fails
 */
export default function parseYamlFile(fileContent) {
  try {
    return yaml.load(fileContent);
  } catch (error) {
    throw new Error(`Failed to parse YAML file: ${error.message}`);
  }
}
